import { TDtoTenantTokenEntry } from "./__types__/TDtoTenantTokenEntry";
import { TParseDto } from "../__types__/dto";
import { isString } from "lodash";

export const DtoTenantTokenParser: TParseDto<TDtoTenantTokenEntry> = (
  data: any
): TDtoTenantTokenEntry => ({
  created_at: isString(data.created_at) ? data.created_at : "",
  id: Number(data.id),
  status: Boolean(data.status),
  tenant_id: Number(data.tenant_id),
  token: isString(data.token) ? data.token : "",
  updated_at: isString(data.updated_at) ? data.updated_at : "",
});
